import styled from 'styled-components';

import { BaseStyle } from '@nhl/nhl-breakaway-ui';

import { WithHidden } from '~/core/styleTypes';

const HEIGHT = '8px';

type WithColor = { $color: string };

export const ProgressBarsContainer = styled.div`
    ${BaseStyle.Mixins.gaps.small}
    display: flex;
`;

export const ProgressBarContainer = styled.div<WithHidden & { $value: number }>`
    display: ${({ $isHidden }) => ($isHidden ? 'none' : 'flex')};
    flex: ${({ $value }) => $value};
`;

export const LeftProgressBar = styled.div<WithColor>`
    width: 100%;
    height: 8px;
    border-top: ${HEIGHT} solid ${({ $color }) => $color};
    border-right: ${HEIGHT} solid transparent;
    border-bottom-left-radius: 1px;
    border-top-left-radius: 1px;
`;

export const RightProgressBar = styled.div<WithColor>`
    width: 100%;
    height: 8px;
    border-bottom: ${HEIGHT} solid ${({ $color }) => $color};
    border-left: ${HEIGHT} solid transparent;
    border-bottom-right-radius: 1px;
    border-top-right-radius: 1px;
`;
